import { TRANSLATION_KEYS } from "constants/translation";

export const FILE_SIZE = [
    { size: { width: 60, height: 50 }, iconSize: { width: 20, height: 20 }, title: TRANSLATION_KEYS.SETTINGS_WINDOW.FILE_SIZE_SMALL },
    { size: { width: 80, height: 70 }, iconSize: { width: 30, height: 30 }, title: TRANSLATION_KEYS.SETTINGS_WINDOW.FILE_SIZE_MEDIUM },
    { size: { width: 100, height: 90 }, iconSize: { width: 40, height: 40 }, title: TRANSLATION_KEYS.SETTINGS_WINDOW.FILE_SIZE_LARGE },
];